<template>
  <BaseLink
    class="text-link"
    @click="emit('click', $event)">
    <slot/>
  </BaseLink>
</template>

<script setup>
import BaseLink from '@shared/components/BaseLink.vue'

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})
</script>

<style lang="scss" scoped>
.text-link {
  &, &:visited {
    color: $primary;
  }
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;

  &:not(:is(span)):hover {
    color: $secondary;
  }

  // BaseLink is a span when disabled
  &:is(span) {
    opacity: 0.6;
    cursor: default;
  }
}
</style>
